import $ from 'jquery';
import Form from '../modules/Form'
class Register extends Form{

    constructor(){

        super();

        this.form = $('#register-form');

        this.errorEl = $("#register-error");

        this.successEl = $("#register-success");

        this.button = this.form.find('#submit-button');

        this.events();

    }

    events(){

        this.form.on('submit', this.submitForm.bind(this));
        
    }
    submitForm(event){

        event.preventDefault();

        const data = {
            username: this.form.find('input[name="log"]').val(),
            password: this.form.find('input[name="pwd"]').val(),
            email: this.form.find('input[name="email"]').val(),
            first_name: this.form.find('input[name="first_name"]').val(),
            last_name: this.form.find('input[name="last_name"]').val(),
            newsletter_consent: Number(this.form.find('#newsletter_consent').attr("value")),
            nonce: jpfRegister.nonce
        }

        this.disableForm();

        this.showprocessMessage();

        $.ajax({
            url: jpfRegister.ajax_url,
            type: 'POST',
            data: {
                action: 'jpf_register',
                formData: JSON.stringify(data)
            },
            success: (response) => {

                if(response.success){

                    this.successMessage(response.message);

                    this.redirect(response.redirect_to);

                } else {

                    this.failedMessage(response.message);

                }

            },
            error: (xhr, status, error) => {
                console.error('Registration failed:', error);
                this.failedMessage('An error occurred. Please try again later.');
            }
        });

    }
    redirect(url){
        window.location.assign(url);
    }
    successMessage(message){

        this.successEl.text(message);
        $(this.successEl).css('display', 'block');

        this.errorEl.text('');
        $(this.errorEl).css('display', 'none');

    }
    failedMessage(message){

        this.errorEl.text(message);
        $(this.errorEl).css('display', 'block');

        this.successEl.text('');
        $(this.successEl).css('display', 'none');

        this.removeprocessMessage();
        this.resetForm();
    }
}
export default Register;